<template><section>
<div class="page">
  <div>
    <h2>Sending photos and videos</h2>
    <h3>Sending photos and videos</h3>
    <ol>
      <li>Open a chat.</li>
      <li>Choose
        <strong>Album, Camera</strong>icon below the text field:
      </li>
      <ol type="a">
        <li>Tap Album to choose a photo or video from your albums.</li>
        <li>Tap <strong>Camera</strong> to take a photo.</li>
        <li>Hold <strong>Camera</strong> to shoot a video.</li>
        <li>Tap <strong>Send</strong>.</li>
      </ol>
    </ol>
    <h3>Forwarding photos and videos</h3>
    <p>To forward photos and videos from one chat to another:</p>
    <ol>
      <li>Open a chat.</li>
      <li>Tap and hold the photo or video you wish to forward, then tap <strong>Forward</strong>.
      </li>
      <li>Choose the chat you wish to forward the photo or video to. Then tap Forward.</li>
    </ol>
    <h6><i>Note: When you forward a photo or video, you don't have to upload it again, and therefore it will send faster
      and use less data.</i></h6>

  </div>
</div>
 </section>
</template>

<script>
    export default {
        components: {},
        data() {
            return {};
        },
        computed: {},
        methods: {}
    }
</script>
